import { render, staticRenderFns } from "./DrugSensitivity.vue?vue&type=template&id=561b0924&"
import script from "./DrugSensitivity.vue?vue&type=script&lang=js&"
export * from "./DrugSensitivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports